import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { FaUserFriends, FaTools, FaAward, FaRegClock } from "react-icons/fa";
import "./Stats.css";

const Stats = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const statsData = [
    { number: 10, suffix: "+", label: "Years of Experience", icon: <FaRegClock /> },
    { number: 1300, suffix: "", label: "Satisfied Clients", icon: <FaUserFriends /> },
    { number: 90, suffix: "", label: "Projects Completed", icon: <FaTools /> },
    { number: 10, suffix: "", label: "Awards Received", icon: <FaAward /> },
  ];

  return (
    <section className="stats-section" ref={ref}>
      <div className="stats-container">
        {statsData.map((item, index) => (
          <div className="stat-card" key={index}>
            <div className="stat-icon">{item.icon}</div>
            <h2 className="stat-number">
              {inView ? <CountUp end={item.number} duration={2} /> : 0}
              <span className="stat-suffix">{item.suffix}</span>
            </h2>
            <p className="stat-label">{item.label}</p>
            {index !== statsData.length - 1 && <div className="divider"></div>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
